/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import '../styles/main.scss';

import React, { useEffect } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import { COLOURS } from '../styles/constants';
import Footer from './footer/Footer';
import Header from './header/header';
import { Nav } from './nav/nav';
import PropTypes from 'prop-types';

if (typeof window !== `undefined`) {
    require('./utils/focus-visible');
}

const Layout = ({ headerTitle, headerIntro, headerImage, children, mapView, footerClassName }) => {
    const data = useStaticQuery(graphql`
        query SiteTitleQuery {
            site {
                siteMetadata {
                    title
                }
            }
        }
    `);

    useEffect(() => {
        // console.log('Running generic helpers');
    }, []);

    return (
        <div className="site-wrap" aria-live="assertive">
            {!mapView && <Header headerTitle={headerTitle} headerIntro={headerIntro} headerImage={headerImage} />}
            <Nav mapView={mapView && mapView} />
            <main className="site-main">{children}</main>
            {!mapView && <Footer footerClassName={footerClassName} />}
            <div className="modal-fade"></div>
        </div>
    );
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    headerTitle: PropTypes.string,
    headerIntro: PropTypes.string,
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Layout;
